import { isNewHomePageApplicable } from '../../constants/feature';

const RenderProdCount = ({ productCount }) => {
  return productCount || productCount === 0 ? `(${productCount})` : isNewHomePageApplicable ? '' : `(...)`;
};

export default RenderProdCount;
